import { Download, Infinity as InfinityIcon, Zap, RefreshCw, Users } from "lucide-react";

const items = [
  { icon: Download, label: "Instant Download" },
  { icon: InfinityIcon, label: "Lifetime Access" },
  { icon: Zap, label: "Actionable Information" },
  { icon: RefreshCw, label: "Regular Updates" },
  { icon: Users, label: "Thousands of Happy Customers" },
];

export const Marquee = () => {
  const row = [...items, ...items, ...items, ...items];
  return (
    <div className="overflow-hidden border-y border-black/10 bg-white py-5" data-testid="features-marquee">
      <div className="marquee-track">
        {row.map((it, i) => (
          <span key={i} className="mx-8 inline-flex items-center gap-2 text-sm uppercase tracking-[0.18em] text-foreground/70">
            <it.icon className="h-4 w-4" /> {it.label}
            <span className="ml-8 text-black/20">/</span>
          </span>
        ))}
      </div>
    </div>
  );
};
